"use strict";

exports.__esModule = true;
exports.createYScales = exports.createScatterPlotYScales = void 0;
var _scales = require("../../../Charts/scales");
var _timeDefinitions = require("../../../timeDefinitions");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var roundToMultipleOfFive = function roundToMultipleOfFive(x) {
  return Math.ceil(x / 5) * 5;
};
var modifyUnitRangeForDuration = function modifyUnitRangeForDuration(unitRange) {
  unitRange.min = 0;
  var maxCeil = 0;
  if (unitRange.max / _timeDefinitions.HOUR_IN_MILLIS > 1) {
    // max is more than 1 hr
    maxCeil = Math.ceil(unitRange.max / _timeDefinitions.HOUR_IN_MILLIS);
    unitRange.max = roundToMultipleOfFive(maxCeil) * _timeDefinitions.HOUR_IN_MILLIS;
  } else if (unitRange.max / _timeDefinitions.MINUTE_IN_MILLIS > 1) {
    // max is more that 1 min.
    maxCeil = Math.ceil(unitRange.max / _timeDefinitions.MINUTE_IN_MILLIS);
    unitRange.max = roundToMultipleOfFive(maxCeil) * _timeDefinitions.MINUTE_IN_MILLIS;
  } else {
    unitRange.max = roundToMultipleOfFive(unitRange.max / _timeDefinitions.SECOND_IN_MILLIS) * _timeDefinitions.SECOND_IN_MILLIS;
  }
  unitRange.tickValues = [0, unitRange.max / 5, unitRange.max * 2 / 5, unitRange.max * 3 / 5, unitRange.max * 4 / 5, unitRange.max];
  return unitRange;
};
var calculateUnitRanges = function calculateUnitRanges(_ref) {
  var series = _ref.series;
  var unitRanges = [];
  var _loop = function _loop() {
    var item = _step.value;
    var unit = item.unit,
      label = item.label;
    var min;
    var max;
    if (unit === "PERCENT") {
      min = 0;
      max = 100;
    } else if (unit === "FRACTIONAL_PERCENT") {
      min = 0;
      max = 100;
    } else if (item.YMax) {
      min = 0;
      max = item.data.reduce(function (pMax, _ref2) {
        var YMax = _ref2.YMax;
        return pMax > YMax ? pMax : YMax;
      }, 0);
    } else {
      min = 0;
      max = 2;
      item.data.map(function (i) {
        if (Array.isArray(i.value)) {
          i.value.map(function (d) {
            if (d.value > max) {
              max = d.value;
            }
          });
        } else {
          if (i.value > max) {
            max = i.value;
          }
        }
      });
    }
    if (min === undefined) {
      min = 0;
    }
    if (max === undefined) {
      max = min + 100;
    }
    var found;
    for (var _i = 0, _unitRanges = unitRanges; _i < _unitRanges.length; _i++) {
      var unitRange = _unitRanges[_i];
      if (unitRange.units === unit) {
        found = unitRange;
        break;
      }
    }
    if (!found) {
      found = {
        units: unit,
        min: min,
        max: max,
        tickValues: [],
        label: label
      };
      unitRanges.push(found);
    } else {
      if (found.min > min) {
        found.min = min;
      }
      if (found.max < max) {
        found.max = max;
      }
    }
  };
  for (var _iterator = _createForOfIteratorHelperLoose(series), _step; !(_step = _iterator()).done;) {
    _loop();
  }
  return unitRanges;
};

/*
  NOTE:: createYScales --> creates multiple scales based on the units of the data.
        It returns a Object with key as the unit the value contains the scale as well as the ticks for the y axis
 */
var createYScales = exports.createYScales = function createYScales(from, to, series) {
  var unitRanges = calculateUnitRanges({
    series: series
  });
  return unitRanges.reduce(function (collected, unitRange) {
    if (unitRange.units === "MILLISECOND") {
      unitRange = modifyUnitRangeForDuration(unitRange);
    }
    collected[unitRange.units] = {
      scale: (0, _scales.createLinearScale)(from, to, [unitRange.min, unitRange.max]),
      tickValues: unitRange.tickValues || [],
      label: unitRange.label
    };
    return collected;
  }, {});
};

// Similar to createYScales, just that its scale's max value is 1.2 X the max value data
var createScatterPlotYScales = exports.createScatterPlotYScales = function createScatterPlotYScales(from, to, series) {
  var unitRanges = calculateUnitRanges({
    series: series
  });
  return unitRanges.reduce(function (collected, unitRange) {
    if (unitRange.units === "MILLISECOND") {
      unitRange = modifyUnitRangeForDuration(unitRange);
    }
    collected[unitRange.units] = {
      scale: (0, _scales.createLinearScale)(from, to, [unitRange.min, unitRange.max * 1.2]),
      tickValues: unitRange.tickValues || [],
      label: unitRange.label
    };
    return collected;
  }, {});
};